import { WaveForm } from "../../../../../../library-js/audio/visualization/wave-form/WaveForm";
import { WaveformChannelType, WaveformGenerationOptions } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormGenerationOptions";
import { WaveFormRenderer } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormRenderer";
import { AttributeValue } from "../../../../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../../../../library-js/dom-tools/ElementType";
import { OnChange, OnLoad } from "../../../../../../library-js/dom-tools/EventListeners";
import { KeyboardSensorID } from "../../../../../../library-js/sensors/KeyboardSensorID";
import { AppCommand } from "../../../../../../library-js/web-app/commands/AppCommand";
import { AppCommandBinding } from "../../../../../../library-js/web-app/commands/AppCommandBinding";
import { AppCommandBindingEntry } from "../../../../../../library-js/web-app/commands/AppCommandBindingEntry";
import { AppCommandContext } from "../../../../../../library-js/web-app/commands/AppCommandContext";
import { AudioEditor } from "../../AudioEditor";
import { ClipCreator } from "../../project/exporting/ClipCreator";
import { ClipExporter } from "../../project/exporting/ClipExporter";

export class ExportAllClips extends AppCommand
{
  initialize()
  {
    this._name = 
    {
      en: "Export All Clips",
      de: "All Clips exportieren" 
    }

    this._info = 
    {
      en: "Exports all clips to a zip file",
      de: "Export die Audio Clips in eine Zip-Datei"
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( AppCommandBinding.primaryWith( KeyboardSensorID.Key_E ) )
    ]
  }

  async _execute( commandContext:AppCommandContext<any,any> ):Promise<void>
  {
    let app = commandContext.webApp as AudioEditor;

    let promise = new Promise<void>(
      async ( resolve, reject )=>
      {
        console.log( "Exporting" );
        let exporter = new ClipExporter();
        exporter.audioEditor = app;

        await exporter.exportClips();

        resolve();
      }
    );

    return Promise.resolve( promise );
  }
}